var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"step-back-button",attrs:{"title":"Voltar"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('img',{attrs:{"src":require("../assets/images/arrow-left.svg"),"alt":"seta voltar"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9a455180","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/StepBackButton.vue
// module id = XXgf
// module chunks = 0